// ============================================================================
// PORTUGUESE TRANSLATIONS - CHAPTER 8: O SOCORRO DO ALTÍSSIMO (BÔNUS)
// ============================================================================
// Nível 92 (1 nível bônus, 3 perguntas)

export const chapter8Translations = {
  name: "O Socorro do Altíssimo",
  description: "Aquele que habita no esconderijo do Altíssimo, à sombra do Onipotente descansará",
  
  spiritualWisdom: {
    principle: "Você chegou ao topo da montanha, e o conhecimento foi adquirido",
    scripture: "Aquele que habita no esconderijo do Altíssimo, à sombra do Onipotente descansará (Salmo 91:1)",
    application: "A fé inabalável requer experiência de vida, misericórdia e o verdadeiro amor de Jesus. As provações testarão seu coração, o verdadeiro caminho escolhido."
  },
  
  levels: {
    92: {
      name: "O Abrigo do Altíssimo",
      challenge: "Você está no topo da montanha... Mas a fé inabalável começa agora...",
      easy: {
        question: "Quem é Jesus para você pessoalmente?",
        options: [
          "Um simples profeta",
          "Meu Senhor e Salvador pessoal",
          "Uma lenda",
          "Um filósofo"
        ],
        hint: "Ele é aquele que dá sua vida para nos salvar",
        funFact: "✝️ Jesus é Deus! Ele não é apenas um personagem histórico - Ele está vivo e deseja um relacionamento pessoal com cada um de nós!"
      },
      medium: {
        question: "Por que jejuar como Daniel nos permite ouvir melhor a Deus?",
        options: [
          "Para perder peso",
          "Para nos privar do que amamos e ter um coração transformado",
          "Para impressionar os outros",
          "Para ser mais forte"
        ],
        hint: "Prive-se do que você mais ama, na calma e na sabedoria",
        funFact: "🙏 O jejum espiritual prepara nosso coração para transformações profundas - muitas vezes dolorosas - que nos aproximam de Deus!"
      },
      hard: {
        question: "Qual é a verdadeira resposta do coração diante de todo esse conhecimento adquirido?",
        options: [
          "Agora sou perfeito",
          "Eu te entrego meu coração Jesus e desejo ser batizado",
          "Sei melhor que os outros",
          "Não preciso mais de ajuda"
        ],
        hint: "A verdadeira fé leva à entrega total e ao compromisso com Jesus",
        funFact: "🌟✨ Você chegou ao topo da montanha, e o conhecimento foi adquirido ✨\n\n💖 A fé inabalável requer experiência de vida, misericórdia e o verdadeiro amor de Jesus 💖\n\n🔥 As diversas provações da vida testarão seu caminho, o verdadeiro trilho que escolhemos, nosso coração 🔥\n\n😔 Permanecemos imperfeitos, nossos desejos são numerosos, e o amor ao ganho ou ao nosso conforto pessoal se torna muito frequentemente nossa prioridade egoísta 😔\n\n🙏 Peça a Deus sabedoria, seu amor, sua força, e reconheça suas fraquezas humildemente, pois não podemos esconder nada Dele... Nada 🙏\n\n🥖 Jejue como Daniel: prive-se por um momento do que você mais ama, na calma e na sabedoria 🥖\n\n💫 Isso lhe permitirá ouvir melhor a Deus, ter uma disposição de coração pronta para transformações profundas 💫\n\n🌙 Então, os sonhos e as visões se tornarão mais claros, como para José 🌙\n\n⚠️ Guarde-se do orgulho: não ceda ao 'sempre tenho razão' ou ao 'sei melhor' ⚠️\n\n🎁 Porque a revelação de Deus é uma graça extraordinária 🎁\n\n💝 Ter fé é entrar em um relacionamento e um caminho livre do coração 💝\n\n🦸‍♂️ Isso fará de você heróis poderosos, capazes do impossível 🦸‍♂️\n\n✝️ No topo do conhecimento, o coração sincero diz: 'Eu te entrego meu coração Jesus e desejo ser batizado' ✝️\n\n🏔️ Você chegou ao topo da montanha, segure firme, persevere! 🏔️\n\n⬇️ É preciso descer e levar este precioso tesouro: a esperança da vida eterna ⬇️\n\n🏆✨ PARABÉNS! ESTAMOS ORGULHOSOS DE VOCÊ ✨🏆\n🌟 CORAGEM VALOROSO PORTADOR DA PAZ 🌟\n🕊️✨ QUE DEUS TE ABENÇOE ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
